import lazyScreen from '../utils/lazyScreen';
const ICReceipt = lazyScreen(() => import('../pages/inv/ICReceipt/index.js'), 'pages/inv/ICReceipt/index.js');
const ICReceipts = lazyScreen(() => import('../pages/inv/ICReceipts/index.js'), 'pages/inv/ICReceipts/index.js');
const ICIssues = lazyScreen(() => import('../pages/inv/ICIssues/index.js'), 'pages/inv/ICIssues/index.js');
const ICIssue = lazyScreen(() => import('../pages/inv/ICIssue/index.js'), 'pages/inv/ICIssue/index.js');
const ICAdjusts = lazyScreen(() => import('../pages/inv/ICAdjusts/index.js'), 'pages/inv/ICAdjusts/index.js');
const ICAdjust = lazyScreen(() => import('../pages/inv/ICAdjust/index.js'), 'pages/inv/ICAdjust/index.js');
const ICTransfers = lazyScreen(() => import('../pages/inv/ICTransfers/index.js'), 'pages/inv/ICTransfers/index.js');
const ICTransfer = lazyScreen(() => import('../pages/inv/ICTransfer/index.js'), 'pages/inv/ICTransfer/index.js');
const ICCounting = lazyScreen(() => import('../pages/inv/ICCounting/index.js'), 'pages/inv/ICCounting/index.js');
const ICCountings = lazyScreen(() => import('../pages/inv/ICCountings/index.js'), 'pages/inv/ICCountings/index.js');
const ICInventories = lazyScreen(() => import('../pages/inv/ICInventories/index.js'), 'pages/inv/ICInventories/index.js');
const ICInventorySerials = lazyScreen(() => import('../pages/inv/ICInventorySerials/index.js'), 'pages/inv/ICInventorySerials/index.js');
const ICInventoryLots = lazyScreen(() => import('../pages/inv/ICInventoryLots/index.js'), 'pages/inv/ICInventoryLots/index.js');
const ICMonthlyReports = lazyScreen(() => import('../pages/inv/ICMonthlyReports/index.js'), 'pages/inv/ICMonthlyReports/index.js');
const ICInventory = lazyScreen(() => import('../pages/inv/ICInventory/index.js'), 'pages/inv/ICInventory/index.js');
const ICValuations = lazyScreen(() => import('../pages/inv/ICValuations/index.js'), 'pages/inv/ICValuations/index.js');
const ICBOM = lazyScreen(() => import('../pages/inv/ICBOM/index.js'), 'pages/inv/ICBOM/index.js');
const ICAssemblyOrder = lazyScreen(() => import('../pages/inv/ICAssemblyOrder/index.js'), 'pages/inv/ICAssemblyOrder/index.js');
const ICAssemblyOrders = lazyScreen(() => import('../pages/inv/ICAssemblyOrders/index.js'), 'pages/inv/ICAssemblyOrders/index.js');
const ICDeassemblyOrder = lazyScreen(() => import('../pages/inv/ICDeassemblyOrder/index.js'), 'pages/inv/ICDeassemblyOrder/index.js');
const ICDeassemblyOrders = lazyScreen(() => import('../pages/inv/ICDeassemblyOrders/index.js'), 'pages/inv/ICDeassemblyOrders/index.js');
const ICLocations = lazyScreen(() => import('../pages/inv/ICLocations/index.js'), 'pages/inv/ICLocations/index.js');
const ICLocation = lazyScreen(() => import('../pages/inv/ICLocation/index.js'), 'pages/inv/ICLocation/index.js');
const ICLocationAudits = lazyScreen(() => import('../pages/inv/ICLocationAudits/index.js'), 'pages/inv/ICLocationAudits/index.js');
const ICLotAudits = lazyScreen(() => import('../pages/inv/ICLotAudits/index.js'), 'pages/inv/ICLotAudits/index.js');
const ICSerialAudits = lazyScreen(() => import('../pages/inv/ICSerialAudits/index.js'), 'pages/inv/ICSerialAudits/index.js');
const ICStockAudit = lazyScreen(() => import('../pages/inv/ICStockAudit/index.js'), 'pages/inv/ICStockAudit/index.js');

var ar = [
    {
        path: '/inv/ICReceipts',
        component: ICReceipts
    },
    {
        path: '/inv/ICReceipt/:code',
        component: ICReceipt
    },
    {
        path: '/inv/ICIssues',
        component: ICIssues
    },
    {
        path: '/inv/ICIssue/:code',
        component: ICIssue
    },
    {
        path: '/inv/ICAdjusts',
        component: ICAdjusts
    },
    {
        path: '/inv/ICAdjust/:code',
        component: ICAdjust
    },
    {
        path: '/inv/ICTransfers',
        component: ICTransfers
    },
    {
        path: '/inv/ICTransfer/:code',
        component: ICTransfer
    },
    {
        path: '/inv/ICCountings',
        component: ICCountings
    },
    {
        path: '/inv/ICCounting/:code',
        component: ICCounting
    },
    {
        path: '/inv/ICInventories',
        component: ICInventories
    },
    {
        path: '/inv/ICInventorySerials',
        component: ICInventorySerials
    },
    {
        path: '/inv/ICInventoryLots',
        component: ICInventoryLots
    },
    {
        path: '/inv/ICMonthlyReports',
        component: ICMonthlyReports
    },
    {
        path: '/inv/ICInventory/:code',
        component: ICInventory
    },
    {
        path: '/inv/ICValuations',
        component: ICValuations
    },
    {
        path: '/inv/ICBOM/:code',
        component: ICBOM
    },
    {
        path: '/inv/ICAssemblyOrders',
        component: ICAssemblyOrders
    },
    {
        path: '/inv/ICAssemblyOrder/:code',
        component: ICAssemblyOrder
    },
    {
        path: '/inv/ICDeassemblyOrders',
        component: ICDeassemblyOrders
    },
    {
        path: '/inv/ICDeassemblyOrder/:code',
        component: ICDeassemblyOrder
    },
    {
        path: '/inv/ICLocations',
        component: ICLocations
    },
    {
        path: '/inv/ICLocation/:code',
        component: ICLocation
    },
    {
        path: '/inv/ICLocationAudits',
        component: ICLocationAudits
    },
    {
        path: '/inv/ICLotAudits',
        component: ICLotAudits
    },
    {
        path: '/inv/ICSerialAudits',
        component: ICSerialAudits
    },
    {
        path: '/inv/ICStockAudit/:code',
        component: ICStockAudit
    },
];

export default ar;
